import { Fragment } from 'react'
import MenuAnimationsAccordion from './menu-animations-accordion'
import MenuAnimationSingleLink from './menu-animation-single-link'
import { menuLinks, type MenuMultipleLinks } from '../menu-constants'
import { MENU_MESSAGE_EDITING, MENU_SECTION_ANIMATION } from 'core/constants/translations/menu'
import MessageAlert from 'components/common/mygame/MessageAlert/message-alert'
import { useTranslation } from 'react-i18next'
import { hasPermission } from '../../../../../core/utils/hasPermission'
import ROLES_MAPPING from '../../../../../core/constants/roles'
import { useApiMenuGetUserPreferences } from '../../../../../core/api/menu/useApiMenuGetUserPreferences'

const MenuAnimation = ({ url, isOpen, isEditing }) => {
  const { t } = useTranslation()
  const { data: user } = useApiMenuGetUserPreferences()

  return (
    <div className="mg-menu-animation">
      <div className="mg-menu-animation-title">
        <span>{t(MENU_SECTION_ANIMATION)}</span>
      </div>
      {isEditing && <MessageAlert icon="info" text={MENU_MESSAGE_EDITING} />}
      <div className="mg-menu-animation-links">
        {menuLinks
          ?.filter(menuLink => hasPermission(user.roles, ROLES_MAPPING, menuLink.rights[0]))
          .map(menuLink => {
            return (
              <Fragment key={menuLink.name}>
                {!(menuLink as MenuMultipleLinks).children ? (
                  <MenuAnimationSingleLink link={menuLink} />
                ) : (
                  <MenuAnimationsAccordion
                    link={menuLink}
                    sublinks={(menuLink as MenuMultipleLinks).children}
                    url={url}
                    isOpen={isOpen}
                  />
                )}
              </Fragment>
            )
          })}
      </div>
    </div>
  )
}

export default MenuAnimation
